import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { EncryptionService } from 'src/app/services/encryption.service';
import { environment } from 'src/environments/environment';
import Swal from "sweetalert2";
import { OrganizerSessionService } from 'src/app/services/organizer-session.service';

@Component({
  selector: 'app-service-agreement',
  templateUrl: './service-agreement.component.html',
  styleUrls: ['./service-agreement.component.scss']
})
export class ServiceAgreementComponent implements OnInit {

  @ViewChild('agreementBox') agreementBox!: ElementRef;

  agreeForm!: FormGroup;
  isScrolledToBottom = false;
  isChecked = false;
  downloadSuccess = false;
  selectedFileName: string | null = null;
  agreement_pdf: any = []
  cleanUrl: any
  encryptOrgID: any;
  decryptedData: any = []
  /** Lead/organizer payload from `GET /leads/:id` (getUniqueUserData). */
  uniqueLeadData: any = null;
  downloadbutton = false;

  /** Signed agreement document URL (upload response or lead `agreement_sign`). */
  get agreementSignUrl(): string | null {
    const u = this.decryptedData?.url;
    return typeof u === 'string' && u.trim() ? u.trim() : null;
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private _ds: DataService,
    private enc: EncryptionService,
    private fb: FormBuilder,
    private organizerSession: OrganizerSessionService,
  ) {
    // this.agreement_pdf = localStorage.getItem('pdf_download');
    // this.cleanUrl = this.agreement_pdf.replace(/"/g, '');

    this.cleanUrl = localStorage
  .getItem('pdf_download')
  ?.replace(/"/g, '') || null;

  }

  ngOnInit(): void {
    // this.agreeForm = this.fb.group({

    //   panNumber: [
    //     '',
    //     [
    //       Validators.required,
    //       Validators.pattern(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/)
    //     ]
    //   ],
    // });

    this.route.queryParams.subscribe((params) => {
      const organizerId = this.organizerSession.validateRouteOrganizerId(
        params['id'],
        '/agreement',
        this.router
      );
      if (organizerId == null) return;

      this._ds.getUniqueUserData(organizerId).subscribe({
        next: (res: any) => {
          const allData = this.enc.decrypt(res.data);
          this.uniqueLeadData = allData;
          this.applyAgreementSignFromLead(allData);
          console.log('getUniqueUserData (agreement page):', allData);
        },
        error: (err) => {
          console.error('getUniqueUserData failed:', err);
        },
      });
    });
  }

  /**
   * If lead already has a signed agreement URL, show it in the file row and keep
   * `decryptedData.url` in sync so submit() works without re-uploading.
   */
  private applyAgreementSignFromLead(allData: any): void {
    const raw =
      allData?.bank_details?.agreement_sign ??
      allData?.organizer?.agreement_sign ??
      allData?.agreement_sign ??
      null;

    if (raw == null || raw === '') {
      return;
    }

    const url =
      typeof raw === 'string'
        ? raw
        : (raw?.url ?? raw?.document_path ?? '');

    if (!url || typeof url !== 'string') {
      return;
    }

    this.decryptedData = { url };
    this.selectedFileName = this.displayNameForStoredAgreement(url);
  }

  private displayNameForStoredAgreement(urlOrPath: string): string {
    const trimmed = urlOrPath.trim();
    try {
      if (trimmed.includes('://')) {
        const path = new URL(trimmed).pathname;
        const base = path.split('/').filter(Boolean).pop();
        if (base) {
          return decodeURIComponent(base);
        }
      }
    } catch {
      /* ignore invalid URL */
    }
    const segments = trimmed.split('/').filter(Boolean);
    const last = segments.pop();
    return last ? decodeURIComponent(last) : trimmed;
  }


  clikedDown() {
    this.downloadbutton = true;
  }
  // downloadAgreement() {
  //   this.downloadSuccess = true;

  //   setTimeout(() => {
  //     this.downloadSuccess = false;
  //   }, 4000);
  // }

  logout() {
    localStorage.clear();
    this.router.navigate(['/login'], { replaceUrl: true });
  }


  downloadAgreement() {
    this.http.get(this.cleanUrl, { responseType: 'blob' }).subscribe(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'agreement.pdf';
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }



  onScroll() {
    const el = this.agreementBox.nativeElement;
    const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 5;
    this.isScrolledToBottom = atBottom;
  }

  // acceptAgreement() {
  //   if (!this.isScrolledToBottom || !this.isChecked) return;
  //   console.log('Agreement Accepted');
  //   this.router.navigate(['/success']);
  // }

  submit() {

    const payload = {
      agreement_sign: this.decryptedData.url,

    };


    console.log('FORM DATA 👉', payload);

    const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
    const user = JSON.parse(localStorage.getItem('user') || 'null');

    const organizeID = {
      organizer_id: organizer?.id || user?.organizer?.id || null
    };

    this._ds.getDataOrganizerId(organizeID).subscribe({
      next: (res: any) => {
        this.encryptOrgID = this.enc.decrypt(res.data)
        //  console.log(this.encryptOrgID)
        this._ds.submitAgreementDetails(this.encryptOrgID.url_safe_organizer_id, payload).subscribe({
          next: (res: any) => {
            if (res?.data) {

              this.updateAgreementService()
              const decryptedData = this.enc.decrypt(res.data);
              console.log('✅ Decrypted response:', decryptedData);

              this.router.navigate(['/success']);
            }
          },
          error: (err) => {
            if (err?.error?.data) {
              const decryptedData = this.enc.decrypt(err.error.data);
              console.log('✅ Decrypted response (409):', decryptedData.error);
              const Toast = Swal.mixin({
                toast: true,
                position: "top",
                showConfirmButton: false,
                timer: 1800,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener("mouseenter", Swal.stopTimer);
                  toast.addEventListener("mouseleave", Swal.resumeTimer);
                },
              });
              Toast.fire({
                title: decryptedData.error,
              });

            } else {
              console.error('❌ No encrypted data found');
            }
          }
        });
      }
    })
  }


  back() {
    // this.router.navigate(['/event-information']); 
    const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
    const user = JSON.parse(localStorage.getItem('user') || 'null');

    // 🔥 pehle user.organizer se try karo
    const orgType = user?.organizer?.organizer_type || organizer?.organizer_type;
    const orgId = user?.organizer?.id || organizer?.id;

    if (!orgType || !orgId) {
      console.error('❌ Organizer data missing in both user & organizer');
      return;
    }
    this.router.navigate(['/platform-legal-organizer'], { queryParams: { id: orgId } });

  }

  onFileSelect(event: any): void {
    let files = event.target.files[0];
    if (files) {
      this.selectedFileName = files.name;
      // const payload ={
      //   document_type:"pan_card",
      //   file:files
      // }
      console.log(files)
      const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
    const user = JSON.parse(localStorage.getItem('user') || 'null');

    const organizerId =
      organizer?.id
        ? organizer.id
        : user?.organizer?.id
          ? user.organizer.id
          : null;

          const firstName =
  organizer?.first_name
    ? organizer.first_name
    : user?.organizer?.first_name
      ? user.organizer.first_name
      : null;

const lastName =
  organizer?.last_name
    ? organizer.last_name
    : user?.organizer?.last_name
      ? user.organizer.last_name
      : null;

    const formData = new FormData();
    formData.append('organizer_name', firstName + ' ' + lastName);
    formData.append('organizer_id', organizerId);
      formData.append('kyc_type', 'bank');
      formData.append('file', files);

      this._ds.uploadDoucment(formData).subscribe({
        next: (res: any) => {
          console.log('Raw success res:', res);

          if (res?.data && typeof res.data === 'string') {
            console.log('Decrypted success:', this.enc.decrypt(res.data));
            this.decryptedData = this.enc.decrypt(res.data)

          } else {
            console.log('Success data not encrypted:', res.data);
          }
        },
        error: (err) => {
          console.log('Raw error:', err);

          if (err?.error?.data && typeof err.error.data === 'string') {
            const decryptedErr = this.enc.decrypt(err.error.data);
            console.log('Decrypted error:', decryptedErr);
          } else {
            console.log('Error data not encrypted:', err?.error);
          }
        }
      });

    }
  }

  triggerFile() {
    const fileInput = document.getElementById('panFile') as HTMLElement;
    fileInput.click();
  }

  viewAgreementSign(): void {
    const url = this.agreementSignUrl;
    if (!url) {
      return;
    }
    const absolute = this.toAbsoluteDocumentUrl(url);
    window.open(absolute, '_blank', 'noopener,noreferrer');
  }

  /** Open uploaded / saved agreement in a new tab (handles relative API paths). */
  private toAbsoluteDocumentUrl(pathOrUrl: string): string {
    const raw = pathOrUrl.trim();
    if (/^https?:\/\//i.test(raw)) {
      return raw;
    }
    if (raw.startsWith('//')) {
      return `${window.location.protocol}${raw}`;
    }
    const base = environment.apiBaseUrl.replace(/\/$/, '');
    if (raw.startsWith('/')) {
      return `${base}${raw}`;
    }
    return `${base}/${raw}`;
  }


  updateAgreementService() {
    const payload = {
      agreement_download: 1,
    };
    // const user = JSON.parse(localStorage.getItem('user') || 'null');

    const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
    const user = JSON.parse(localStorage.getItem('user') || 'null');

    const organizerId =
      organizer?.id
        ? organizer.id
        : user?.organizer?.id
          ? user.organizer.id
          : null;

    this._ds.updateAgreementID(organizerId, payload).subscribe({
      next: (res: any) => {
        this.enc.decrypt(res.data)
        console.log(res.data)

      }
    })

  }

}
